<div id="interactive-map"
    *ngIf="((selectedFeelings && selectedSymptom && selectedFeelings.length > 0) || (!activeDomain && !isViewOnly) || (activeDomain && !isViewOnly))"
     class="card card--box"
     [class.view-mode]="isViewOnly"
     [class.fullscreen]="isFullScreen"
     [class.comparison-mode]="isComparisonViewMode"
     [class.simple-legends]="showLegends"
     [class.collapsed]="isCollapsed">
    <div class="" [ngStyle]="{'background-image': 'url(/assets/img/pages/tasklist-done-'+ lang +'.gif)'}">
    </div>
    <div *ngIf="selectedFeelings && selectedSymptom && selectedFeelings.length > 0"
        [class.animate]="!isViewOnly"
        class="symptom-details">
        <perfect-scrollbar #psSymptom>
            <div class="interactive-tasks tasklists--wrapper tasklists--wrapper--symptom card card--box col-md-12"
                 [class.sticky]="!isViewOnly"
                 [class.pt-0]="!isViewOnly">
                <div class="tasklists--wrapper__header"
                     [class.sticky]="!isViewOnly"
                     [style.right]= "!isViewOnly ? '-6px' : '6px'">
                     <i [ngClass]="isViewOnly ? 'btn-close fal fa-times' : 'back fas fa-long-arrow-left'" (click)="closeDetails(isViewOnly)"></i>
                    <h2 class="tasklists--wrapper__title">
                        {{ selectedSymptom['formatted_neutral_name_' + lang] ||  selectedSymptom['name_' + lang] }}
                    </h2>
                </div>

                <div class="row tasklists--wrapper__rating">
                    <div class="col-md-12 tasklists--wrapper__rating__points">
                        <feeling-selection [selectedFeelings]="selectedFeelings" [selectedSymptom]="selectedSymptom" [selectedFeeling]="selectedFeeling" [selectionList]="selectionList" [lang]="lang" [nodeClassList]="nodeClassList" (changeRating)="updateRating($event.selectedFeeling, $event.status, $event.selectedSymptom, $event.isAnamnestic)" (changePrimary)="updatePrimary($event.feeling)"> </feeling-selection>
                    </div>
                </div>

                <div class="row tasklists--wrapper__statement" #symptomStatement>
                    <div class="col-md-12 tasklists--wrapper__statement__label">{{'Statement' | translate }}</div>
                    <ng-container *ngIf="selectedSymptom.have_statement">
                        <ng-container *ngFor="let feeling of selectedFeelings">
                            <h4 class="tasklists--wrapper__statement__feeling-name col-md-12" *ngIf="selectedFeelings.length > 1">
                                {{ feeling['name_' + lang] }}
                            </h4>
                            <div class="col-md-12 tasklists--wrapper__statement__description"
                                 [innerHTML]="feeling['statement_' + lang] || ''" #statement>
                            </div>
                        </ng-container>
                    </ng-container>
                    <ng-container *ngIf="!selectedSymptom.have_statement">
                        <div class="col-md-12 tasklists--wrapper__statement__description" #statement>
                            {{ 'Expert Item: No statement was shown.' | translate }}
                        </div>
                    </ng-container>
                </div>

                <hr />

                <div #symptomQuestion class="row tasklists--wrapper__statement">
                    <div class="col-md-12 tasklists--wrapper__statement__label">{{'Question' | translate }}</div>
                    <div class="col-md-12 tasklists--wrapper__statement__description"
                         [innerHTML]="selectedFeelings[0]['question_' + lang] || '' | safeHtml" #description>
                    </div>
                </div>
                <hr />

                <div class="row tasklists--wrapper__statement" *ngIf="selectedFeelings[0]['definition_' + lang] !== null && selectedFeelings[0]['definition_' + lang] !== '<p>---</p>'">
                    <div class="col-md-3 tasklists--wrapper__statement__label">
                        {{ 'Definition' | translate }}
                    </div>

                    <div class="col-md-12 tasklists--wrapper__statement__description"
                         [innerHTML]="selectedFeelings[0]['definition_' + lang] | safeHtml" #statement>
                         {{ selectedFeelings[0]['definition_' + lang] }}
                    </div>
                </div>

                <div class="row tasklists--wrapper__footer">
                </div>
            </div>
        </perfect-scrollbar>
    </div>

    <div class="panel-heading col-md-12 sticky tasklists--wrapper interactive-tasks" *ngIf="!activeDomain && !isViewOnly">
        <div class="tasklists--wrapper__header tasklists sticky">
            <!--    TASK LISTS  -->
            <h2 class="tasklists--wrapper__title">
                {{ 'Task lists' | translate }}
            </h2>
            <hr />
            <ul class="nav nav-justified nav-tabs mb-1">
                <li class="nav-item" [class.active]="tabSelected === 0" (click)="selectTab(0)">
                    <a class="nav-link" [class.active]="tabSelected === 0">
                        <span class="badge badge-secondary flex-center">
                            {{ 'To do' | translate }}
                        </span>
                    </a>
                </li>
                <li class="nav-item" [class.active]="tabSelected === 1" (click)="selectTab(1)">
                    <a class="nav-link" [class.active]="tabSelected === 1">
                        <span class="badge badge-secondary flex-center" [class.update-count]="countUpdated !== counting.done">
                            {{ 'Done' | translate }} ({{counting.done}}/{{counting.total}})
                        </span>
                    </a>
                </li>
            </ul>
        </div>
        <tabset #tabs [justified]="true" class="tasklists">
            <tab (select)="selectTab(0)" class="tasklists--tab">
                <ng-template tabHeading>
                    <span class="badge badge-secondary flex-center">
                        {{ 'To do' | translate }}
                    </span>
                </ng-template>
                <ng-container *ngIf="counting.done === counting.total && initMapCompleted && !isCollapsed">
                    <div class="no-item {{ translate.currentLang }}" id="finish-animation"
                         [class.no-animation]="!finishedCV">
                        <div class="row no-item--navigate" *ngIf="patientService.enableProposal">
                            <div class="col-md-6">
                                <button class="btn btn-primary btn-radius" (click)="openProposalDiagnosis.emit()">
                                    {{ 'Possible diagnoses' | translate }}
                                </button>
                            </div>
                            <div class="col-md-6">
                                <button class="btn btn-secondary btn-radius pull-right" (click)="navigateToPatients()">
                                    {{ 'Patients List' | translate }}
                                </button>
                            </div>
                        </div>
                        <div class="row no-item--navigate w-100" *ngIf="!patientService.enableProposal">
                            <div class="col-md-12">
                                <button class="btn btn-secondary btn-radius" (click)="navigateToPatients()">
                                    {{ 'Patients List' | translate }}
                                </button>
                            </div>
                        </div>
                    </div>
                </ng-container>
                <ng-container *ngIf="counting.done !== counting.total && mapData.domain.length">
                    <div class="row" *ngFor="let domain of mapData.domain; let i = index">
                        <div *ngIf="domain.is_marked === 0 && domain.is_show_on_task_list" class="col-md-12 tasklists--wrapper__statement" [class.animate-marked]="domain['passed']">
                            <div class="row">
                                <div class=" col-md-8 tasklists--wrapper__statement__label domain-name" (click)="setActiveDomain(domain)">{{ domain['name_' + lang] }}</div>
                            </div>
                            <div class="tasklists--wrapper__tags">
                                <span class="tasklists--wrapper__tags__item badge badge-secondary" [class.active]="domain['is_highlight'] === domainColor.unhighlight" (click)="updateDomain(domain, {is_highlight : domainColor.unhighlight})">{{'Subclinical' | translate}}</span>
                                <span class="tasklists--wrapper__tags__item badge badge-secondary" [class.active]="domain['is_highlight'] === domainColor.highlight" (click)="updateDomain(domain, {is_highlight : domainColor.highlight})">{{'Clin. relevant' | translate}}</span>
                                <span class="tasklists--wrapper__tags__item badge badge-secondary" [class.active]="domain['is_highlight'] === domainColor.grey" (click)="updateDomain(domain, {is_highlight : domainColor.grey})">{{'Remitted' | translate}}</span>
                            </div>
                            <ng-container *ngIf="authService.clinic && authService.clinic.b2c_register">
                                <div class="row mt-1">
                                    <div class="col-md-8"><b>{{ 'Estimated impairment' | translate }}</b></div>
                                </div>
                                <div class="mt-1 tasklists--wrapper__tags">
                                    <span [class.active]="domain['rating'] === domainRating.mild" class="tasklists--wrapper__tags__item badge domain-rating badge-secondary" (click)="updateDomain(domain, {rating : domainRating.mild})">{{'Mild' | translate}}</span>
                                    <span [class.active]="domain['rating'] === domainRating.mildtomiddle" class="tasklists--wrapper__tags__item domain-rating badge domain-rating badge-secondary" (click)="updateDomain(domain, {rating : domainRating.mildtomiddle})">{{'Mild to middle' | translate}}</span>
                                    <span [class.active]="domain['rating'] === domainRating.middle" class="tasklists--wrapper__tags__item badge domain-rating badge-secondary" (click)="updateDomain(domain, {rating : domainRating.middle})">{{'Middle' | translate}}</span>
                                    <span [class.active]="domain['rating'] === domainRating.middletosevere" class="tasklists--wrapper__tags__item badge domain-rating badge-secondary" (click)="updateDomain(domain, {rating : domainRating.middletosevere})">{{'Middle to severe' | translate}}</span>
                                    <span [class.active]="domain['rating'] === domainRating.severe" class="tasklists--wrapper__tags__item badge domain-rating badge-secondary" (click)="updateDomain(domain, {rating : domainRating.severe})">{{'Severe' | translate}}</span>
                                </div>
                            </ng-container>
                            <div class="tasklists--wrapper__rating pt-0">
                                <div class="tasklists--wrapper__rating__points item-block mt-0 normal-{{symptom.is_normal}} marked-{{symptom.is_marked}}"
                                     (mouseover)="setHighlightSymptom($event, symptom)"
                                     (mouseout)="unhighLightSymptom($event, false)"
                                     [class.animate-marked]="symptom.passed"
                                     *ngFor="let symptom of domain.symptoms; let i = index">
                                    <ng-container *ngIf="symptom.is_normal === 0 && !symptom.is_marked">
                                        <feeling-list-selection 
                                            [activeDomain]="domain" 
                                            [symptom]="symptom" 
                                            [selectionList]="selectionList" 
                                            [lang]="lang" 
                                            [nodeClassList]="nodeClassList"
                                            (changeRating)="updateRatingTaskList($event.activeDomain, $event.symptom, $event.position, $event.status, $event.isAnamnestic)" 
                                            (changePrimary)="updatePrimary($event.feeling, $event.symptom)"
                                            (changeActiveSymptom)="setActiveSymptom($event.symptom, $event.domain)">
                                        </feeling-list-selection>
                                    </ng-container>
                                </div>
                                <div class="tasklists--wrapper__rating__points mt-0">
                                    <div class="col-md-11 pl-0 tasklists--wrapper__rating__list mark-checked">
                                        <label (click)="updateDomain(domain, {is_marked : 1})">
                                            {{ 'Mark areas as checked' | translate}}
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </ng-container>
            </tab>
            <tab (select)="selectTab(1)" class="tasklists--tab donelist" [ngClass]="''">
                <ng-template tabHeading>
                    <span class="badge badge-secondary flex-center" [class.update-count]="countUpdated !== counting.done">
                        {{ 'Done' | translate }} ({{counting.done}}/{{counting.total}})
                    </span>
                </ng-template>
                <perfect-scrollbar #ps *ngIf="!isViewOnly">
                <ng-container *ngIf="mapData.domain.length">
                    <div class="row" *ngFor="let domain of mapData.domain; let i = index">
                        <div *ngIf="(domain.is_marked === 1 || domain.symptom_marked_count > 0) && domain.is_show_on_task_list" class="col-md-12 tasklists--wrapper__statement" [class.animate-marked]="domain['reject']">
                            <div class="row">
                                <div class=" col-md-8 tasklists--wrapper__statement__label domain-name" (click)="setActiveDomain(domain)">{{ domain['name_' + lang] }}</div>
                            </div>
                            <div class="tasklists--wrapper__tags">
                                <span [class.active]="domain['is_highlight'] === domainColor.unhighlight" class="tasklists--wrapper__tags__item badge badge-secondary" (click)="updateDomain(domain, {is_highlight : domainColor.unhighlight})">{{'Subclinical' | translate}}</span>
                                <span [class.active]="domain['is_highlight'] === domainColor.highlight" class="tasklists--wrapper__tags__item badge badge-secondary" (click)="updateDomain(domain, {is_highlight : domainColor.highlight})">{{'Clin. relevant' | translate}}</span>
                                <span [class.active]="domain['is_highlight'] === domainColor.grey" class="tasklists--wrapper__tags__item badge badge-secondary" (click)="updateDomain(domain, {is_highlight : domainColor.grey})">{{'Remitted' | translate}}</span>
                            </div>
                            <ng-container *ngIf="authService.clinic && authService.clinic.b2c_register">
                                <div class="row mt-1">
                                    <div class="col-md-8"><b>{{ 'Estimated impairment' | translate }}</b></div>
                                </div>
                                <div class="mt-1 tasklists--wrapper__tags" *ngIf="authService.clinic && authService.clinic.b2c_register">
                                    <span [class.active]="domain['rating'] === domainRating.mild" class="tasklists--wrapper__tags__item badge domain-rating badge-secondary" (click)="updateDomain(domain, {rating : domainRating.mild})">{{'Mild' | translate}}</span>
                                    <span [class.active]="domain['rating'] === domainRating.mildtomiddle" class="tasklists--wrapper__tags__item domain-rating badge badge-secondary" (click)="updateDomain(domain, {rating : domainRating.mildtomiddle})">{{'Mild to middle' | translate}}</span>
                                    <span [class.active]="domain['rating'] === domainRating.middle" class="tasklists--wrapper__tags__item badge domain-rating badge-secondary" (click)="updateDomain(domain, {rating : domainRating.middle})">{{'Middle' | translate}}</span>
                                    <span [class.active]="domain['rating'] === domainRating.middletosevere" class="tasklists--wrapper__tags__item domain-rating badge badge-secondary" (click)="updateDomain(domain, {rating : domainRating.middletosevere})">{{'Middle to severe' | translate}}</span>
                                    <span [class.active]="domain['rating'] === domainRating.severe" class="tasklists--wrapper__tags__item domain-rating badge badge-secondary" (click)="updateDomain(domain, {rating : domainRating.severe})">{{'Severe' | translate}}</span>
                                </div>
                            </ng-container>
                            <div class="tasklists--wrapper__rating pt-0">
                                <div class="tasklists--wrapper__rating__points mt-0"
                                     (mouseover)="setHighlightSymptom($event, symptom)"
                                     (mouseout)="unhighLightSymptom($event, false)"
                                     *ngFor="let symptom of domain.symptoms; let i = index">
                                    <feeling-list-selection 
                                            [activeDomain]="domain" 
                                            [symptom]="symptom" 
                                            [selectionList]="selectionList" 
                                            [lang]="lang" 
                                            [nodeClassList]="nodeClassList"
                                            (changeRating)="updateRatingTaskList($event.activeDomain, $event.symptom, $event.position, $event.status, $event.isAnamnestic)" (changePrimary)="updatePrimary($event.feeling, $event.symptom)">
                                    </feeling-list-selection>
                                </div>
                                <div *ngIf="domain.is_marked === 1" class="tasklists--wrapper__rating__points mt-0">
                                    <div class="col-md-11 pl-0 tasklists--wrapper__rating__list mark-checked">
                                        <label (click)="updateDomain(domain, {is_marked : 0})">
                                            {{ 'Mark areas as unchecked' | translate}}
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </ng-container>
                </perfect-scrollbar>
            </tab>
        </tabset>
    </div>

    <!--    DOMAIN LEVEL    -->
    <div class="panel-heading col-md-12 tasklists--wrapper sticky interactive-tasks tasklists--wrapper--domain" *ngIf="activeDomain">
            <!--    TASK LISTS  -->
            <div class="tasklists--wrapper__header sticky">
                <i class="back fas fa-long-arrow-left" (click)="goBack(true)"></i>
                <div class="row">
                    <div class=" col-md-12 tasklists--wrapper__statement__label domain-name hover-n">{{ activeDomain['name_' + lang] }}</div>
                </div>
                <div class="tasklists--wrapper__tags">
                    <span [class.active]="activeDomain['is_highlight'] === domainColor.unhighlight" class="tasklists--wrapper__tags__item badge badge-secondary" (click)="updateDomain(activeDomain, {is_highlight : domainColor.unhighlight})">{{'Subclinical' | translate}}</span>
                    <span [class.active]="activeDomain['is_highlight'] === domainColor.highlight" class="tasklists--wrapper__tags__item badge badge-secondary" (click)="updateDomain(activeDomain, {is_highlight : domainColor.highlight})">{{'Clin. relevant' | translate}}</span>
                    <span [class.active]="activeDomain['is_highlight'] === domainColor.grey" class="tasklists--wrapper__tags__item badge badge-secondary" (click)="updateDomain(activeDomain, {is_highlight : domainColor.grey})">{{'Remitted' | translate}}</span>
                </div>
                <ng-container *ngIf="authService.clinic && authService.clinic.b2c_register">
                    <div class="mt-1 row">
                        <div class="col-md-8"><b>{{ 'Estimated impairment' | translate }}</b></div>
                    </div>
                    <div class="mt-1 tasklists--wrapper__tags" *ngIf="authService.clinic && authService.clinic.b2c_register">
                        <span [class.active]="activeDomain['rating'] === domainRating.mild" class="tasklists--wrapper__tags__item domain-rating badge badge-secondary" (click)="updateDomain(activeDomain, {rating : domainRating.mild})">{{'Mild' | translate}}</span>
                        <span [class.active]="activeDomain['rating'] === domainRating.mildtomiddle" class="tasklists--wrapper__tags__item domain-rating badge badge-secondary" (click)="updateDomain(activeDomain, {rating : domainRating.mildtomiddle})">{{'Mild to middle' | translate}}</span>
                        <span [class.active]="activeDomain['rating'] === domainRating.middle" class="tasklists--wrapper__tags__item domain-rating badge badge-secondary" (click)="updateDomain(activeDomain, {rating : domainRating.middle})">{{'Middle' | translate}}</span>
                        <span [class.active]="activeDomain['rating'] === domainRating.middletosevere" class="tasklists--wrapper__tags__item domain-rating badge badge-secondary" (click)="updateDomain(activeDomain, {rating : domainRating.middletosevere})">{{'Middle to severe' | translate}}</span>
                        <span [class.active]="activeDomain['rating'] === domainRating.severe" class="tasklists--wrapper__tags__item domain-rating badge badge-secondary" (click)="updateDomain(activeDomain, {rating : domainRating.severe})">{{'Severe' | translate}}</span>
                    </div>
                </ng-container>
            </div>
            <div class="row">
                <div class="col-md-12 tasklists--wrapper__statement">
                    <!--    EXPERT ITEMS    -->
                    <ng-container *ngIf="activeDomain.total_expert_items">
                        <div class="tasklists--wrapper__statement__label mr-t--md">
                            {{ 'Expert items' | translate }}
                        </div>
                        <div class="tasklists--wrapper__rating pt-0">
                            <div class="tasklists--wrapper__rating__points mt-0"
                                 (mouseover)="setHighlightSymptom($event, symptom)"
                                 (mouseout)="unhighLightSymptom($event, false)"
                                 *ngFor="let symptom of activeDomain.symptoms; let i = index">
                                <ng-container *ngIf="symptom.is_normal === 0">
                                    <feeling-list-selection 
                                        [activeDomain]="activeDomain" 
                                        [symptom]="symptom" 
                                        [selectionList]="selectionList" 
                                        [lang]="lang" 
                                        [nodeClassList]="nodeClassList"
                                        (changeRating)="updateRatingTaskList($event.activeDomain, $event.symptom, $event.position, $event.status, $event.isAnamnestic)" 
                                        (changePrimary)="updatePrimary($event.feeling, $event.symptom)"
                                        (changeActiveSymptom)="setActiveSymptom($event.symptom, $event.domain)">
                                    </feeling-list-selection>
                                </ng-container>
                            </div>
                        </div>
                        <div class="clear"></div>
                    </ng-container>
                    <!--    / EXPERT ITEMS  -->

                    <!--    NORMAL ITEM -->
                    <ng-container *ngIf="(activeDomain?.symptoms?.length - activeDomain?.total_expert_items) > 0">
                        <div class="tasklists--wrapper__statement__label mr-t--md">
                            {{ 'Self-evaluation items' | translate }}
                        </div>
                        <div class="tasklists--wrapper__rating pt-0">
                        <div class="tasklists--wrapper__rating__points mt-0"
                             (mouseover)="setHighlightSymptom($event, symptom)"
                             (mouseout)="unhighLightSymptom($event, false)"
                             *ngFor="let symptom of activeDomain.symptoms; let i = index">
                            <ng-container *ngIf="symptom.is_normal !== 0">
                                <feeling-list-selection 
                                    [activeDomain]="activeDomain" 
                                    [symptom]="symptom" 
                                    [selectionList]="selectionList" 
                                    [lang]="lang" 
                                    [nodeClassList]="nodeClassList"
                                    (changeRating)="updateRatingTaskList($event.activeDomain, $event.symptom, $event.position, $event.status, $event.isAnamnestic)" 
                                    (changePrimary)="updatePrimary($event.feeling, $event.symptom)"
                                    (changeActiveSymptom)="setActiveSymptom($event.symptom, $event.domain)">
                                </feeling-list-selection>
                            </ng-container>
                        </div>
                    </div>
                    </ng-container>
                    <!--    NORMAL ITEM -->
                </div>
            </div>
        </div>

</div>
